import { Component, OnInit,  EventEmitter, ElementRef, Input,Output, OnDestroy } from '@angular/core';
import {StreamsService}  from "../../shared/services/streams.service";
import {  NbToastrService, NbGlobalPosition, NbDialogService } from '@nebular/theme';
import {PanelVisibilityService} from '../../shared/services/panel-visibility.service'
 import {visibilityPanelAnimation} from '../../shared/classes/visibility-panel.animation'

@Component({
  selector: 'app-stream-move-from-video',
  templateUrl: './stream-move-from-video.component.html',
  styleUrls: ['./stream-move-from-video.component.scss'],
  animations: [visibilityPanelAnimation]
})
export class StreamMoveFromVideoComponent implements OnInit, OnDestroy {
 
	@Input() stream:any;
    @Output() onMoved = new EventEmitter<boolean>();

         proccess$:any = null;
	  selectedVideo:any = null;
          loading:boolean = false;

	constructor(
	  public streamsService: StreamsService,
    	  private toastrService: NbToastrService,
    	  private dialogService: NbDialogService,
          public panelVisibility: PanelVisibilityService
	){}


	 ngOnInit(): void {}

	 


   showToastCopyClipboard(text,type ){

    this.toastrService.show('',text,{
      status: type,
      icon: '',
      position: <NbGlobalPosition>'bottom-end'
        })
   }


 openDialog(content){
 
     this.dialogService.open(content, {
      dialogClass: 'settings-modalsscrollable-container',
      
    });
}

   startProccess(modal:any){

	modal.close()

	this.loading = true
	  if(this.proccess$){this.proccess$.unsubscribe()}

	this.proccess$ = this.streamsService.moveFromVideoToStream(this.selectedVideo._id, this.stream._id).subscribe((data)=>{


	this.loading = false;
	this.showToastCopyClipboard('Трансляція замінена','success');
	this.selectedVideo = null

         this.onMoved.emit(true)
	},(err)=>{
 
		this.loading = false; 

		if(err.status === 404){
		 this.showToastCopyClipboard('Відео не завантажено','danger')
		}else{
		 this.showToastCopyClipboard('Сталася помилка','danger')
		}

		 })
	 

  }


	 ngOnDestroy(): void {       

	  if(this.proccess$){this.proccess$.unsubscribe()}
 
	 }


	
}
